import script from "./ProvidersMegaMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvidersMegaMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProvidersMegaMenu.vue?vue&type=style&index=0&id=0f853d58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f853d58"]])

export default __exports__